import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { ApiKeyProvider } from './context/ApiKeyContext';
import HomePage from './pages/HomePage';
import ModePage from './pages/ModePage';
import DifficultyPage from './pages/DifficultyPage';
import PersonalityPage from './pages/PersonalityPage';
import ChatPage from './pages/ChatPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

// Global styles
const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 400;
  }

  h1, h2, h3 {
    font-family: 'Fraunces', Georgia, serif;
    font-weight: 500;
    letter-spacing: -0.01em;
  }

  body {
    background-color: #f8f9fa;
    color: #333;
    line-height: 1.5;
  }

  button {
    cursor: pointer;
    font-weight: 500;
  }
`;

function App() {
  return (
    <ApiKeyProvider>
      <GlobalStyle />
      {/* Served at the root of its own domain, so the router lives at "/". */}
      <Router basename="/">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/mode" element={<ModePage />} />
          <Route path="/date-in-eight" element={<DifficultyPage />} />
          <Route path="/personality" element={<PersonalityPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ApiKeyProvider>
  );
}

export default App;
